const SP_BASE = "https://terrenospr.sharepoint.com/sites/ODAP317";
const LIST_GUID = "452e8a00-83d6-475f-8b38-23b33e1427c5";

export interface CpcaCase {
  id: number;
  numeroSolicitud: string;
  nombreSolicitante: string;
  municipio: string;
  finca: string;
  proposito: string;
  tipo: string;
  asignadoA: string;
  asignadoAEmail: string;
  tasador: string;
  tasadorEmail: string;
  estado: string;
  estadoTasador: string;
  fechaAsignacion: string | null;
  fechaSubida: string | null;
  fechaActa: string | null;
  fechaAsignacionTasador: string | null;
  fechaSubidaTasador: string | null;
  comentariosRechazo: string;
  comentariosRechazoTasador: string;
  modified: string | null;
}

// Internal names verified from /_api/web/lists(...)/fields
const SELECT = [
  "ID",
  "Title",                                  // Numero-Solicitud
  "field_1",                                // Nombre-Solicitante
  "field_2",                                // Municipio
  "field_3",                                // Finca
  "field_4",                                // Proposito
  "field_5",                                // Tipo
  "field_7",                                // Estado
  "AsignadoA/Title",
  "AsignadoA/EMail",
  "Tasador/Title",
  "Tasador/EMail",
  "Estado_x002d_Tasador",
  "FechadeRadicacion",                      // Fecha-Asignacion
  "Fecha_x002d_Subida",
  "Fecha_x002d_Acta",
  "Fecha_x002d_Asignacion_x002d_Tas",      // Fecha-Asignacion-Tasador
  "Fecha_x002d_Subida_x002d_Tasador",
  "Comentarios_x002d_Rechazo",
  "Comentarios_x002d_Rechazo_x002d_",      // Comentarios-Rechazo-Tasador (truncated by SP)
  "Modified",
].join(",");

export async function fetchCpcaCases(token: string): Promise<CpcaCase[]> {
  const url =
    `${SP_BASE}/_api/web/lists(guid'${LIST_GUID}')/items` +
    `?$select=${SELECT}&$expand=AsignadoA,Tasador&$top=5000`;

  const resp = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json;odata=nometadata",
    },
  });

  if (!resp.ok) {
    let detail = "";
    try { detail = await resp.text(); } catch { /* ignore */ }
    throw new Error(`SharePoint fetch failed: ${resp.status} ${resp.statusText}${detail ? " — " + detail.slice(0, 400) : ""}`);
  }

  const data = await resp.json();
  return (data.value as Record<string, unknown>[]).map(mapCase);
}

function str(v: unknown): string {
  return (v as string) ?? "";
}

function mapCase(e: Record<string, unknown>): CpcaCase {
  const assignedTo = (e.AsignadoA as Record<string, string> | null) ?? {};
  const tasador = (e.Tasador as Record<string, string> | null) ?? {};
  return {
    id: (e.ID as number) ?? 0,
    numeroSolicitud: str(e.Title),
    nombreSolicitante: str(e.field_1),
    municipio: str(e.field_2),
    finca: str(e.field_3),
    proposito: str(e.field_4),
    tipo: str(e.field_5),
    asignadoA: assignedTo.Title ?? "",
    asignadoAEmail: assignedTo.EMail ?? "",
    tasador: tasador.Title ?? "",
    tasadorEmail: tasador.EMail ?? "",
    estado: str(e.field_7),
    estadoTasador: str(e["Estado_x002d_Tasador"]),
    fechaAsignacion: (e.FechadeRadicacion as string | null) ?? null,
    fechaSubida: (e["Fecha_x002d_Subida"] as string | null) ?? null,
    fechaActa: (e["Fecha_x002d_Acta"] as string | null) ?? null,
    fechaAsignacionTasador: (e["Fecha_x002d_Asignacion_x002d_Tas"] as string | null) ?? null,
    fechaSubidaTasador: (e["Fecha_x002d_Subida_x002d_Tasador"] as string | null) ?? null,
    comentariosRechazo: str(e["Comentarios_x002d_Rechazo"]),
    comentariosRechazoTasador: str(e["Comentarios_x002d_Rechazo_x002d_"]),
    modified: (e.Modified as string | null) ?? null,
  };
}
